import React from "react";
import { Modal } from "antd";
import { useDispatch } from "react-redux";
import { updateShowRequestAlert } from "@features/modalSlice";
import { AiOutlineClose } from "react-icons/ai";
import { FaExclamationCircle } from "react-icons/fa";

interface IRequestAlertProps {
    showRequestAlert: boolean;
    bodyComponent: React.ReactElement<HTMLDivElement>;
    footerComponent: React.ReactElement<HTMLDivElement>;
}

const RequestAlertModal: React.FC<IRequestAlertProps> = (props) => {
    const { showRequestAlert, bodyComponent, footerComponent } = props;
    const dispatch = useDispatch();
    const closeShowRequestAlert = () =>
        dispatch(updateShowRequestAlert(!showRequestAlert));

    return (
        <>
            <Modal
                title={
                    <div className="d-flex pb-2 align-items-center">
                        <span className="fs-3 d-flex align-items-center">
                            <FaExclamationCircle className="text-danger me-2" />
                            <span>Alert</span>
                        </span>
                    </div>
                }
                closeIcon={<AiOutlineClose style={{ fontSize: "35px" }} />}
                open={showRequestAlert}
                onCancel={closeShowRequestAlert}
                keyboard={false}
                maskClosable={false}
                footer={footerComponent}
            >
                {bodyComponent}
            </Modal>
        </>
    );
};

export default RequestAlertModal;
